import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useId } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Checkbox } from '../Checkbox/index.esm.js';
import { CheckboxContext } from '../CheckboxContext/index.esm.js';
import { ErrorMessage } from '../ErrorMessage/index.esm.js';
import { Fieldset } from '../Fieldset/index.esm.js';
import '@skatteetaten/ds-icons';
import '../Help/index.esm.js';
import 'react-i18next';
import '@skatteetaten/ds-buttons';
import './styles.css';


var styles = {
    "errorMessage": "CheckboxGroup-module_errorMessage__qbAk-"
};

const CheckboxGroup = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), classNames, lang, 'data-testid': dataTestId, description, errorMessage, helpSvgPath, helpText, legend, titleHelpSvg, disabled, form, hideLegend, showRequiredMark, onHelpToggle, children }, ref)=>{
    const errorId = `checkboxGroupErrorId-${useId()}`;
    return /*#__PURE__*/ jsxs(Fieldset, {
        ref: ref,
        id: id,
        className: className,
        classNames: classNames,
        lang: lang,
        "data-testid": dataTestId,
        disabled: disabled,
        form: form,
        legend: legend,
        hideLegend: hideLegend,
        showRequiredMark: showRequiredMark,
        description: description,
        helpSvgPath: helpSvgPath,
        helpText: helpText,
        titleHelpSvg: titleHelpSvg,
        hasSpacing: true,
        onHelpToggle: onHelpToggle,
        children: [
            /*#__PURE__*/ jsx(CheckboxContext.Provider, {
                value: {
                    errorId: errorMessage ? errorId : undefined
                },
                children: children
            }),
            /*#__PURE__*/ jsx(ErrorMessage, {
                className: `${styles.errorMessage} ${classNames?.errorMessage ?? ''}`.trim(),
                id: errorId,
                showError: !!errorMessage,
                children: errorMessage
            })
        ]
    });
});
CheckboxGroup.displayName = 'CheckboxGroup';
CheckboxGroup.Checkbox = Checkbox;

export { CheckboxGroup };
